export { default } from "./patientSignature";
